import type { CustomAudiencesApiContext } from '../types';

/**
 * Lets a nested load drop its write once the load that started it is superseded.
 *
 * `isCurrent` is read after the responses arrive; false drops the write.
 */
export type LoadGuard = { isCurrent?: () => boolean };

/** Whether a load for `ctx` may still write: its signal has not aborted, the store holds the same brand, and the guard, if any, is current. */
export const mayWrite = (
  loadedBrandId: string | null,
  ctx: CustomAudiencesApiContext,
  guard: LoadGuard = {}
): boolean =>
  !ctx.signal?.aborted &&
  (loadedBrandId == null || loadedBrandId === ctx.brandId) &&
  (guard.isCurrent?.() ?? true);
